
export interface TransferOfChargeEntity {
    id: number,
    dtlState?: string | null,
    seqNo?: string | null,
    chargeOnCompany?: string | null,
    billToCompany?: string | null,
    consortiumCode?: string | null,
    vesselCode?: string | null,
    voyageCode?: string | null,
    etd?: string | null,
    chargeType?: string | null,
    subChargeType?: string | null,
    cntrNo?: string | null,
    status?: string | null,
    cntrSize?: string | null,
    cntrType?: string | null,
    serviceOrderCode?: string | null,
    tariffType?: string | null,
    tariffCode?: string | null,
    qty?: string | null,
    uom?: string | null,
    opsLine?: string | null,
    cnicNo?: string | null,
    vehicleNo?: string | null,
    damageType?: string | null,
    amount?: string | null,
    remark?: string | null,
    commodityCode?: string | null,
    counterCustCompCode?: string | null,
    draftInvoiceNo?: string | null,
    finalInvoiceNo?: string | null,
    draftCreditNoteNo?: string | null,
    finalCreditNoteNo?: string | null,
    adjType?: string | null,
    mcNo?: string | null,
    crNo?: string | null,
    cntrTypeGroup?: string | null,
    opsDate?: string | null,
    billOfLading?: string | null,
    shippingBill?: string | null,
    serviceCode?: string | null,
    agentNo?: string | null,
    agentName?: string | null,
    paidThroughDate?: string | null,
    operatingTml?: string | null,
    changeDateTime?: string | null,
    releaseDateTime?: string | null,
    oneoffRate?: string | null,
    specialInd?: string | null,
    vesselName?: string | null,
    oriOwner?: string | null,
    oriStatus?: string | null,
    newOwner?: string | null,
    newStatus?: string | null,
    chargeCode?: string | null,
    telexNo?: string | null,
    chargeInd?: string | null,
    shipmentType?: string | null,
    forwarderReference?: string | null,
    bageJobID?: string | null,
    arrDateTime?: string | null,
    otherArrDateTime?: string | null,
    otherDepDateTime?: string | null,
    otherService?: string | null,
    pod2?: string | null,
    pod1GeogInd?: string | null,
    requestDateTime?: string | null,
    reasonCode?: string | null,
    receiveDateTime?: string | null,
    loadingDateTime?: string | null,
    firstLoadingDataTime?: string | null,
    lastLoadingDateTime?: string | null,
    chargingFromDateTime?: string | null,
    chargingToDateTime?: string | null,
    recevalCutoffDateTime?: string | null,
    firstTierFsp?: string | null,
    secondTierFsp?: string | null,
    chargingQtyAdjust?: string | null,
    calendarAdjustChargeqty?: string | null,
    manualAdjustChargeQty?: string | null,
    manualAdjustUOM?: string | null,
    dgContent?: string | null,
    duContent?: string | null,
    permitNo?: string | null,
    rfTemp?: string | null,
    rfTempUnit?: string | null,
    dIndDischargeInd?: string | null,
    soNumber?: string | null,
    trainId?: string | null,
    tractorNo?: string | null,
    fdGeogInd?: string | null,
    waiverNo?: string | null,
    pooGeogInd?: string | null,
    polGeogInd?: string | null,
    eqCodeInd?: string | null,
    eqCode?: string | null,
    noOfStorage?: string | null,
    dischargeDateTime?: string | null,
    firstDischargeDateTime?: string | null,
    lastDischargeDateTime?: string | null,
    expDateTime?: string | null,
    deliveryDateTime?: string | null,
    atb?: string | null,
    cashOtDays?: string | null,
    cashAmount?: string | null,
    cashReceiptNo?: string | null,
    imcoCode?: string | null,
    specialCode?: string | null,
    spHandlingInd?: string | null,
    poo?: string | null,
    pol?: string | null,
    pod?: string | null,
    fd?: string | null,
    pooCountry?: string | null,
    polCountry?: string | null,
    podCountry?: string | null,
    fdCountry?: string | null,
    excessWeight?: string | null,
    grossWeight?: string | null,
    maxGrossWeight?: string | null,
    cargoCode?: string | null,
    waiverReasonCode?: string | null,
    waiverRejectReasonCode?: string | null,
    waiverApprovedBy?: string | null,
    waiverApprovedDatetime?: string | null,
    exciseCashNo?: string | null,
    liftInd?: string | null,
    waiverNoOfDays?: string | null,
    serviceReferenceNo?: string | null,
    serviceRequestCode?: string | null,
    subServiceRequestCode?: string | null,
    exceptionMsg?: string | null,
    lsLocationType?: string | null,
    cntrNoRef?: string | null,
    iocBatchPaymentCntrSeq?: string | null,

    [key: string]: string | number | Date | null | undefined
}

export const EMPTY_TRANSFER_OF_CHARGE_ENTITY: TransferOfChargeEntity = {
    id: 0,
    dtlState: '',
    seqNo: '',
    chargeOnCompany: '',
    billToCompany: '',
    consortiumCode: '',
    vesselCode: '',
    voyageCode: '',
    etd: '',
    chargeType: '',
    subChargeType: '',
    cntrNo: '',
    status: '',
    cntrSize: '',
    cntrType: '',
    serviceOrderCode: '',
    tariffType: '',
    tariffCode: '',
    qty: '',
    uom: '',
    opsLine: '',
    cnicNo: '',
    vehicleNo: '',
    damageType: '',
    amount: '',
    remark: '',
    commodityCode: '',
    counterCustCompCode: '',
    draftInvoiceNo: '',
    finalInvoiceNo: '',
    draftCreditNoteNo: '',
    finalCreditNoteNo: '',
    adjType: '',
    mcNo: '',
    crNo: '',
    cntrTypeGroup: '',
    opsDate: '',
    billOfLading: '',
    shippingBill: '',
    serviceCode: '',
    agentNo: '',
    agentName: '',
    paidThroughDate: '',
    operatingTml: '',
    changeDateTime: '',
    releaseDateTime: '',
    oneoffRate: '',
    specialInd: '',
    vesselName: '',
    oriOwner: '',
    oriStatus: '',
    newOwner: '',
    newStatus: '',
    chargeCode: '',
    telexNo: '',
    chargeInd: '',
    shipmentType: '',
    forwarderReference: '',
    bageJobID: '',
    arrDateTime: '',
    otherArrDateTime: '',
    otherDepDateTime: '',
    otherService: '',
    pod2: '',
    pod1GeogInd: '',
    requestDateTime: '',
    reasonCode: '',
    receiveDateTime: '',
    loadingDateTime: '',
    firstLoadingDataTime: '',
    lastLoadingDateTime: '',
    chargingFromDateTime: '',
    chargingToDateTime: '',
    recevalCutoffDateTime: '',
    firstTierFsp: '',
    secondTierFsp: '',
    chargingQtyAdjust: '',
    calendarAdjustChargeqty: '',
    manualAdjustChargeQty: '',
    manualAdjustUOM: '',
    dgContent: '',
    duContent: '',
    permitNo: '',
    rfTemp: '',
    rfTempUnit: '',
    dIndDischargeInd: '',
    soNumber: '',
    trainId: '',
    tractorNo: '',
    fdGeogInd: '',
    waiverNo: '',
    pooGeogInd: '',
    polGeogInd: '',
    eqCodeInd: '',
    eqCode: '',
    noOfStorage: '',
    dischargeDateTime: '',
    firstDischargeDateTime: '',
    lastDischargeDateTime: '',
    expDateTime: '',
    deliveryDateTime: '',
    atb: '',
    cashOtDays: '',
    cashAmount: '',
    cashReceiptNo: '',
    imcoCode: '',
    specialCode: '',
    spHandlingInd: '',
    poo: '',
    pol: '',
    pod: '',
    fd: '',
    pooCountry: '',
    polCountry: '',
    podCountry: '',
    fdCountry: '',
    excessWeight: '',
    grossWeight: '',
    maxGrossWeight: '',
    cargoCode: '',
    waiverReasonCode: '',
    waiverRejectReasonCode: '',
    waiverApprovedBy: '',
    waiverApprovedDatetime: '',
    exciseCashNo: '',
    liftInd: '',
    waiverNoOfDays: '',
    serviceReferenceNo: '',
    serviceRequestCode: '',
    subServiceRequestCode: '',
    exceptionMsg: '',
    lsLocationType: '',
    cntrNoRef: '',
    iocBatchPaymentCntrSeq: '',

}